import styled from '@emotion/styled';

import { head, isEmpty } from 'lodash';

import { ContentType, DealProduct, DirectOrderType } from '../../../types';
import usePickProduct from '../../../hooks/usePickProduct';

import SelectedProductItem from './selected-product/SelectedProductItem';
import MultiSelectedProductItem from './MultiSelectedProductItem';
import { useAppSelector } from '../../../../../shared/store';
import {
  selectCurrentTotalPoint,
  selectCurrentTotalPrice,
  selectRestockNotifiableDealProducts,
} from '../../../selectors';

import PurchasePriceResult from '../ATF/buy-section/PurchasePriceResult';
import PurchaseButtonGroup from '../ATF/buy-section/PurchaseButtonGroup';

const ProductItemWrapper = styled.div`
  margin-top: 20px;
`;

const PurchasePriceResultWrapper = styled.div`
  padding-top: 20px;
`;

const PurchaseActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PurchaseButtonGroupWrapper = styled.div`
  width: 428px;
  margin-bottom: 60px;
`;

interface Props {
  loggedIn: boolean;
  buyText: string;
  onClickCartButton(): void;
  productNo: number;
  dealProducts: DealProduct[];
  contentType: ContentType;
  isSoldOut: boolean;
  isPurchaseStatus: boolean;
  canRestockNotify: boolean;
  isDiscountProduct: boolean;
  isExpectedPoint: boolean;
  directOrderType: DirectOrderType;
}

export default function BuyFooter({
  loggedIn,
  buyText,
  onClickCartButton,
  productNo,
  dealProducts,
  contentType,
  isSoldOut,
  isPurchaseStatus,
  canRestockNotify,
  isDiscountProduct,
  isExpectedPoint,
  directOrderType,
}: Props) {
  const restockNotifiableDealProducts = useAppSelector(selectRestockNotifiableDealProducts);
  const totalPrice = useAppSelector(selectCurrentTotalPrice);
  const totalPoint = useAppSelector(selectCurrentTotalPoint);

  const resultTotalPoint = isExpectedPoint ? totalPoint : 0;

  const isRestockNotificationAvailable = canRestockNotify && !isEmpty(restockNotifiableDealProducts);

  const {
    isActiveLike,
    toggleLike,
  } = usePickProduct(productNo);

  const headOfDealProducts = head(dealProducts);

  if (!headOfDealProducts) {
    return <ProductItemWrapper>상품정보가 올바르지 않습니다.</ProductItemWrapper>;
  }

  return (
    <>
      <ProductItemWrapper>
        {contentType === 'MULTI' ? (
          <MultiSelectedProductItem
            dealProducts={dealProducts}
            directOrderType={directOrderType}
          />
        ) : (
          <SelectedProductItem
            dealProduct={headOfDealProducts}
            directOrderType={directOrderType}
          />
        )}
      </ProductItemWrapper>
      <PurchasePriceResultWrapper>
        <PurchasePriceResult
          loggedIn={loggedIn}
          totalPrice={totalPrice}
          totalPoint={resultTotalPoint}
          isDiscountProduct={isDiscountProduct}
        />
      </PurchasePriceResultWrapper>
      <PurchaseActionSection>
        <PurchaseButtonGroupWrapper>
          <PurchaseButtonGroup
            isActiveLike={isActiveLike}
            toggleLike={toggleLike}
            isRestockNotificationAvailable={isRestockNotificationAvailable}
            buyText={buyText}
            onClickCartButton={onClickCartButton}
            disabled={isSoldOut || !isPurchaseStatus}
          />
        </PurchaseButtonGroupWrapper>
      </PurchaseActionSection>
    </>
  );
}
